import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "midTitle" }
const _hoisted_2 = { class: "mapContainer mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_map_component = _resolveComponent("map-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        localizedKey: "Seleziona il centro sulla mappa",
        text: "Seleziona il centro sulla mappa"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_map_component, {
        class: "prenotaMap",
        pins: _ctx.pins,
        pinCallback: _ctx.pinCallback
      }, null, 8, ["pins", "pinCallback"])
    ])
  ], 64))
}